"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var componentOverrides = __importStar(require("./overrides"));
var utils_1 = require("@material-ui/utils");
var keyRegex = /create(\w+)Override/;
var getOverrideKey = function (override) {
    var result = keyRegex.exec(override);
    return result && result[1];
};
exports.createOverrides = function (theme, options) {
    if (options === void 0) { options = {}; }
    var defaultOverrides = Object.entries(componentOverrides).reduce(function (prev, _a) {
        var _b;
        var key = _a[0], getStyles = _a[1];
        var overrideKey = getOverrideKey(key);
        if (!overrideKey)
            return prev;
        return __assign(__assign({}, prev), (_b = {}, _b[overrideKey] = getStyles(theme), _b));
    }, {});
    var customOverrides = typeof options === "function" ? options(theme) : options;
    return utils_1.deepmerge(defaultOverrides, customOverrides, { clone: false });
};
//# sourceMappingURL=createOverrides.js.map